export default __webpack_public_path__ + "static/media/BlissPro-Regular.708746ef.eot";